var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tree',{ref:"authTree",attrs:{"data":_vm.tree,"show-checkbox":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }